export interface ThreatStatusLabelProps {
  threatStatus: number | string | null;
  showOrb?: boolean;
  showColor?: boolean;
  labelText?: string;
  labelPrefix?: string;
  url?: string;
  openNewTab?: boolean;
  showTitle?: boolean;
  riskScore?: number;
  className?: string;
  onClick?: () => void;
}
